import {
    BlackPearlTemplate,
    defaultTemplate,
    IBannerComponent,
    ILogoComponent,
    ISignatureComponent,
} from "@blackpearlmail/cerberus"

import { defaultBanner, defaultLogo } from "../components/configurator/components/cards/images/model"
import { addDisclaimer } from "./functions"

export const blackPearlTemplate: BlackPearlTemplate = {
    style: { ...defaultTemplate.style, colour: "transparent", kind: "fixed" },
    components: addDisclaimer(
        defaultTemplate.components.map((component) => {
            if (component.type === "SignatureComponent") {
                return {
                    ...component,
                    ...{ fontPrimaryColour: "#5E8598" },
                    ...{ fontSecondaryColour: "#6E6E6E" },
                    ...{
                        profileImage: {
                            horizontalAlignment: "left",
                            width: 100,
                            height: 100,
                            verticalAlignment: "top",
                        },
                    },
                    ...{ socialMedia: { ...component.socialMedia, color: "#5E8598" } },
                } as ISignatureComponent
            }
            if (component.type === "ContentComponent") {
                return {
                    ...component,
                    sampleContent: `<div style="color: #3b3b3b">Hi Sam,<br>
                           <br>
                        Guess what? I got notified that someone clicked on my email 🤩 I followed up with them and made the sale!<br>
                        <br>
                        Talk soon,</div>`,
                }
            }
            if (component.type === "LogoComponent" || component.type === "BannerComponent") {
                if (component.name === "image below signature") {
                    return {
                        ...component,
                        ...defaultBanner,
                    } as IBannerComponent
                }

                if (component.name === "image at top") {
                    return {
                        ...component,
                        ...defaultLogo,
                    } as ILogoComponent
                }
            }
            return component
        })
    ),
}
